import { CompanyCreationDocumentType } from '__generated__/GQL';
import assertEventType from 'common/bento/lib/assertEventType';
import { MachineGuards } from 'common/bento/types/MachineConfig';

import { Model } from './model';

export enum Guard {
  IsSelectedDocumentHandWrittenProofOfIdentity = 'isSelectedDocumentHandWrittenProofOfIdentity',
}

const guards: MachineGuards<Model, Guard> = {
  isSelectedDocumentHandWrittenProofOfIdentity: (_context, event) => {
    assertEventType(event, 'SELECT_DOCUMENT');

    return (
      event?.documentType ===
      CompanyCreationDocumentType.ProofOfIdentityHandWritten
    );
  },
};

export default guards;
